<template>
	<div class="assistance">
		<ic-form-row-horizontal2 aria="Pole jest wymagane" label="W obrębie dworca do/od drzwi pociągu" new_id="atStation" :labelWidth="4" :controlWidth="8" :error="hasError('form.assistance.atStation')" :required="isRequired('form.assistance.atStation')">
			<ic-checkbox-group 
 				   id="atStation" v-model="assistance.atStation" :options="assistanceAtStationTypes" :v="v.form.assistance.atStation" :allowEmpty="false"
                ></ic-checkbox-group> 

			
			<!-- <ic-select v-if="assistance.meetingPlace != 'platform'" id="atStation" v-model="assistance.atStation" :values="assistanceAtStationTypes" :v="v.form.assistance.atStation" :multiple="true" 
			:placeholder="'... (Wybierz jedną lub kilka z '+assistanceAtStationTypes.length+' opcji)'" :allowEmpty="false"></ic-select> -->
			<!-- <div class="form-control-static" v-if="assistance.meetingPlace == 'platform'">Nie dotyczy</div> -->
		</ic-form-row-horizontal2>
		<div >
			<div class="row g-3">
				<div class="col-sm-8 offset-sm-4" ><p v-html="$t('assistance_at_station_conditions')"></p></div>
			</div>		
			<ic-form-row-horizontal2 new_id="atStationRemarks" :labelWidth="4" :controlWidth="8" label="Dodatkowe informacje dotyczące asysty w obrębie dworca">
				
				<ic-textarea id="atStationRemarks" v-model="assistance.atStationRemarks" 
				placeholder="np. będzie potrzebny wózek inwalidzki będący na wyposażeniu PKP S.A. albo pomoc będzie potrzebna na wybranych stacjach, tj. A, B i C" aria-labelledby="atStationRemarks_label"></ic-textarea>
			</ic-form-row-horizontal2>
		</div>
		<ic-form-row-horizontal2 aria="Pole jest wymagane" label="Pomoc w pociągu" new_id="inTrain" :labelWidth="4" :controlWidth="8" :error="hasError('form.assistance.inTrain')" :required="isRequired('form.assistance.inTrain')">
			<ic-checkbox-group 
			id="inTrain" v-model="assistance.inTrain" :options="assistanceInTrainTypes" :multiple="true" :v="v.form.assistance.inTrain" 
			:placeholder="'... (Wybierz jedną lub kilka z '+assistanceInTrainTypes.length+' opcji)'"   :allowEmpty="false"
                ></ic-checkbox-group> 

			<!-- <ic-select id="inTrain" v-model="assistance.inTrain" :values="assistanceInTrainTypes" :multiple="true" :v="v.form.assistance.inTrain" 
			:placeholder="'... (Wybierz jedną lub kilka z '+assistanceInTrainTypes.length+' opcji)'"   :allowEmpty="false"></ic-select> -->
		</ic-form-row-horizontal2>
		<div class="row g-3">
			<div class="col-sm-8 offset-sm-4" ><p v-html="$t('assistance_in_train_conditions')"></p></div>
		</div>
		<ic-form-row-horizontal2 aria="Pole jest wymagane" label="Bagaż podręczny" new_id="baggage" :labelWidth="4" :controlWidth="8" :error="hasError('form.assistance.baggage')" :required="isRequired('form.assistance.baggage')">
			<ic-checkbox-group
			id="baggage"  v-model="assistance.baggage" :options="assistanceBaggageTypes" :multiple="true" :v="v.form.assistance.baggage" 
			:placeholder="'... (Wybierz jedną lub kilka z '+assistanceBaggageTypes.length+' opcji)'"   :allowEmpty="false"
			></ic-checkbox-group>
			<!-- <ic-select id="baggage"  v-model="assistance.baggage" :values="assistanceBaggageTypes" :multiple="true" :v="v.form.assistance.baggage" 
			:placeholder="'... (Wybierz jedną lub kilka z '+assistanceBaggageTypes.length+' opcji)'"   :allowEmpty="false"></ic-select> -->
		</ic-form-row-horizontal2>
        <ic-form-row-horizontal2
            new_id="size"
            v-if="assistance.baggage.length && assistance.baggage[0] != 'na'"
            :error="hasError('form.assistance.baggage_size')"
            label=" "
            :labelWidth="4" :controlWidth="8" 
          >
           
            <ic-checkbox
              id="baggage_size"
              aria="Pole jest wymagane"
              v-model="assistance.baggage_size"

              :val="1"
              :v="v.form.assistance.baggage_size"
            > {{$t('baggage_size_description')}} *</ic-checkbox>
          </ic-form-row-horizontal2>
		<ic-form-row-horizontal2 aria="Pole jest wymagane" label="Miejsce spotkania" new_id="meetingPlace" :labelWidth="4" :controlWidth="8" :error="hasError('form.assistance.meetingPlace')" :required="isRequired('form.assistance.meetingPlace')">
			<ic-select-system id="meetingPlace" v-model="assistance.meetingPlace" :values="meetingPlaceTypes" :v="v.form.assistance.meetingPlace"  :placeholder="'... (Wybierz jedną z opcji)'" :allowEmpty="false"></ic-select-system> 
		</ic-form-row-horizontal2>
		
		<ic-form-row-horizontal2 new_id="prmImage" v-if="assistance.meetingPlace == 'prm'" :labelWidth="4" :controlWidth="8">
			<p>Sprawdź <a @click.prevent="oznStations" href="https://www.pkp.pl/pl/bez-barier">wykaz dworców</a>, na których wyznaczono miejsca spotkań.</p>
			<p aria-hidden="true">Rysunek przedstawiający tablicę miejsca wyznaczonego do spotkań osoby z niepełnosprawnością z asystą na dworcu.</p>
			<img src="/ax26hrxl857-a/components/icformozn/img/baner_bottom_form_ozn1.jpg" class="img-responsive" alt="Rysunek przedstawiający wygląd oznaczenia miejsca oczekiwania dla osób z niepełnosprawnością ruchową"/>

		</ic-form-row-horizontal2>

		<!-- <ic-form-row-horizontal2 id="meetingPlaceCashNo" :labelWidth="4" :controlWidth="8" v-if="assistance.meetingPlace === 'cash_1'" :error="hasError('form.assistance.meetingPlaceCashNo')" :required="isRequired('form.assistance.meetingPlaceCashNo')">
			<div class="row g-3">
				<div class="col-md-3">
					<label for="meetingPlaceCashNo" class="control-label control-label-medium">Nr kasy:<span class="sr-only">Pole jest wymagane</span></label>		
				</div>
				<div class="col-md-3">
					<ic-input id="meetingPlaceCashNo" v-model="assistance.meetingPlaceCashNo" :v="v.form.assistance.meetingPlaceCashNo"></ic-input>
				</div>
			</div>
		</ic-form-row-horizontal2> -->

		<ic-form-row-horizontal2 new_id="meetingPlaceOther" :labelWidth="4" :controlWidth="8" v-if="assistance.meetingPlace === 'other'" :error="hasError('form.assistance.meetingPlaceOther')" :required="isRequired('form.assistance.meetingPlaceOther')">
			<label for="meetingPlaceOther">Proszę napisać:</label>
			<ic-textarea v-model="assistance.meetingPlaceOther" id="meetingPlaceOther" :v="v.form.assistance.meetingPlaceOther"></ic-textarea>
		</ic-form-row-horizontal2>
	</div>
</template>

<script>
	import IcFormRowHorizontal from '@/components/ic-common/form/helpers/FormRowHorizontal.vue'
	import IcFormRowHorizontal2 from '@/components/ic-common/form/helpers/FormRowHorizontal2.vue'
	import IcSelect from '@/components/ic-common/form/controls/Select.vue'
	import IcSelectSystem from '@/components/ic-common/form/controls/SelectControl.vue'
	import IcTextarea from '@/components/ic-common/form/controls/Textarea.vue'
	import IcInput from '@/components/ic-common/form/controls/Input.vue'
	import IcCheckbox from "@/components/ic-common/form/controls/Checkbox.vue";
	import IcCheckboxGroup from "@/components/ic-common/form/controls/CheckboxGroup.vue";
	import IcFormRow from "@/components/ic-common/form/helpers/FormRow.vue";
	import {assistanceAtStationTypes, assistanceInTrainTypes, assistanceBaggageTypes, meetingPlaceTypes} from './storage'

	export default {
		name: 'IcFormOznAssistance',
		props: {
			value: {
				type: Object,
				required: true
			},
			v: {
				type: Object
			},
			hasError: {
				type: Function
			},
		    isRequired: {
		    	type: Function,
		    	required: false
		    }
		},
		data() {
			return {
				assistance: this.value,
				assistanceAtStationTypes: assistanceAtStationTypes,
				assistanceInTrainTypes: assistanceInTrainTypes,
				assistanceBaggageTypes: assistanceBaggageTypes,
				meetingPlaceTypes: meetingPlaceTypes			}
		},
		watch: {
			'assistance.meetingPlace' : function(newValue, oldValue) {
				if (newValue !== oldValue) {
					// if (newValue === 'platform') {
					// 	this.assistance.atStation = ['none'];
					// } else if (oldValue === 'platform') {
					// 	this.assistance.atStation = [];
					// }
				}
			}
		},
		methods: {
			oznStations(e) {
				let href = 'https://www.pkp.pl/pl/dworce/informacje-dla-pasazerow-niepelnosprawnych-lub-o-ograniczonej-sprawnosci-ruchowej'
				let opts = 'width=400,height=600,location=no,menubar=no,status=no,titlebar=no,toolbar=no';
				window.open(href, 'Wykaz stacji', opts)
				return false
			}
		},
		components: {
			IcSelect,
			IcFormRowHorizontal,
			IcFormRowHorizontal2,
			IcTextarea,
			IcInput,
			IcFormRow,
			IcCheckbox,
			IcSelectSystem,
			IcCheckboxGroup
		}
	}
</script>

<style>
	#form-ozn__form .assistance .form-control-static {
		background: #ebebeb;
		padding: 5px 10px 0;
		height: 30px;
	}
</style>